import { KulionerListRequest } from "@/data/payload/api/KulionerApiRequest";
import { DownloadReportRequest } from "@/domain/entities/Kulioner";

export class KulionerEndpoint {
  getKulionerList(params: KulionerListRequest) {
    return `/hydra/v1/kulioner/order?${params.toQueryString()}`;
  }
  getKulionerDetail(id: number) {
    return `/hydra/v1/kulioner/order/${id}`;
  }
  getDownloadReports(params: DownloadReportRequest) {
    return `/hydra/v1/kulioner/download?${params.toQueryString()}`;
  }
  updateKulioner() {
    return '/hydra/v1/kulioner/order/process';
  }
  updateToggle(id: number) {
    return `/hydra/v1/kulioner/order/${id}/mark-as-processed`;
  }
  getListSummaryStatus(params: KulionerListRequest) {
    return `/hydra/v1/kulioner/order/status?${params.toQueryString()}`;
  }
}
